var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',[_c('br'),_c('fields-list',{attrs:{"item":_vm.item,"fields":_vm.fields}}),_c('div',{staticClass:"save-panel"},[_c('button',{staticClass:"btn btn-warning btn-icon",on:{"click":_vm.updateItem}},[_c('span',{staticClass:"ti-save"}),_vm._v(_vm._s(_vm._f("setText")("save","Сохранить"))+"\n    ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }